module.exports = __webpack_public_path__ + "static/img/banner-4.a0c60c36.jpg";